import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Signup } from './pages/Signup'
import { Verify } from './pages/Verify'
import { Login } from './pages/Login'
import { TotpLogin } from './pages/TotpLogin'
import { Dashboard } from './pages/Dashboard'
import { Sites } from './pages/Sites'
import { ApiKeys } from './pages/ApiKeys'
import { Credits } from './pages/Credits'
import { SiteDetail } from './pages/SiteDetail'
import { Onboarding } from './pages/Onboarding'
import { RunView } from './pages/RunView'
import { TotpSetupPassword } from './pages/TotpSetupPassword'
import { TotpSetupConfirm } from './pages/TotpSetupConfirm'

export function App() {
  return (
    // The Go server only serves this SPA under /app/* (main.go's registerSPA); without
    // this basename every navigate()/<Link> call produces an absolute path like "/login"
    // instead of "/app/login". That URL renders fine via client-side routing right up
    // until a hard refresh, which is a real request the Go server has no route for -> 404.
    <BrowserRouter basename="/app">
      <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/totp" element={<TotpLogin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/sites/:id" element={<SiteDetail />} />
        <Route path="/sites/:id/setup" element={<Onboarding />} />
        <Route path="/keys" element={<ApiKeys />} />
        <Route path="/credits" element={<Credits />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/runs/:id" element={<RunView />} />
        <Route path="/totp/setup" element={<TotpSetupPassword />} />
        <Route path="/totp/setup/confirm" element={<TotpSetupConfirm />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
